import React, { Component } from "react";
import PropTypes from "prop-types";
import setWelcomeMessageClosed from "./setWelcomeMessageClosed";
import getWelcomeMessageClosedState from "./getWelcomeMessageClosedState";
import { getContext } from "@src/client/context";
import withTranslation from "../../translation";
import {
  trackPageInteraction,
  ANALYTICS_CONTEXT,
  ANALYTICS_INTERACTION_NAVIGATE,
  ANALYTICS_INTERACTION_CLOSE
} from "@src/helpers/events";
import IconButton from "../../IconButton";
import styles from "../deferred.css";

class WelcomeMessage extends Component {
  state = {
    isClosed: getWelcomeMessageClosedState()
  };

  componentDidMount() {
    if (!this.state.isClosed) {
      this.props.trackImpression();
    }
  }

  setClosedState = () => {
    setWelcomeMessageClosed();

    this.setState({
      isClosed: true
    });
  };

  handleClose = () => {
    trackPageInteraction({
      context: ANALYTICS_CONTEXT.welcomeMessage,
      interaction: ANALYTICS_INTERACTION_CLOSE
    });

    this.setClosedState();
  };

  handleNavigation = (context, url) => e => {
    e.preventDefault();

    const {
      country: { countryCode, siteId, storeCode },
      siteId: currentSiteId
    } = this.props;

    const currentBrowseCountry = context.getBrowseCountry();
    const currentStoreCode = context.getStoreId();

    trackPageInteraction({
      context: ANALYTICS_CONTEXT.welcomeMessage,
      interaction: ANALYTICS_INTERACTION_NAVIGATE,
      properties: {
        current: {
          countryCode: currentBrowseCountry,
          siteId: currentSiteId,
          storeCode: currentStoreCode
        },
        new: {
          countryCode,
          siteId,
          storeCode
        }
      }
    });

    this.setClosedState();

    window.location.assign(url);
  };

  render() {
    if (this.state.isClosed) {
      return null;
    }

    const {
      country: {
        imageUrl,
        countryCode: browseCountry,
        defaultCurrency: browseCurrency
      },
      formatTranslation,
      redirectUrl: { url, label },
      text
    } = this.props;

    const context = getContext();
    const affid = context.getAffiliateId();

    url.query = {
      ...url.query,
      r: 1,
      ctaref: "welcome mat",
      browseCountry,
      browseCurrency,
      ...(affid ? { xaffid: affid } : {})
    };

    const fullUrl = url.toString();

    return (
      <div
        className={styles.container}
        role="region"
        aria-labelledby="welcomeMessageText"
        data-testid="welcome-message"
      >
        <div className={styles.wrapper} role="alert" aria-live="assertive">
          <img
            src={imageUrl}
            alt=""
            className={styles.flag}
            data-testid="icon"
          />
          <div>
            <p className={styles.text} id="WelcomeMessageText">
              {text}
            </p>
            <a
              onClick={this.handleNavigation(context, fullUrl)}
              className={styles.redirectLink}
              href={fullUrl}
              data-testid="welcome-message-link"
            >
              {label}
            </a>
          </div>
          <IconButton
            icon={styles.closeIcon}
            className={styles.close}
            data-testid="close-button"
            onClick={this.handleClose}
            aria-label={formatTranslation("icon_close")}
          />
        </div>
      </div>
    );
  }
}

WelcomeMessage.propTypes = {
  redirectUrl: PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.object.isRequired
  }).isRequired,
  text: PropTypes.string.isRequired,
  country: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    defaultCurrency: PropTypes.string.isRequired,
    siteId: PropTypes.number.isRequired,
    storeCode: PropTypes.string.isRequired
  }).isRequired,
  formatTranslation: PropTypes.func.isRequired,
  trackImpression: PropTypes.func.isRequired,
  siteId: PropTypes.number.isRequired
};

export default withTranslation(WelcomeMessage);
